import { useQuery } from '@tanstack/react-query';

import { postPlaidCreateTokenLink } from '@arrived/api_v2';
import { PlaidCreateTokenLinkRequest, PlaidCreateTokenLinkResponse } from '@arrived/models';

import { UseQueryOptions } from '../../queries.utils';
import { useGetCurrentUserQuery } from '../../users';
import { plaidTokenLinkKeyFn } from '../accounts.keys';

export function usePlaidTokenLinkQuery(
  request?: Omit<PlaidCreateTokenLinkRequest, 'userId'>,
  options?: UseQueryOptions<PlaidCreateTokenLinkResponse>
) {
  const currentUser = useGetCurrentUserQuery();

  const userId = currentUser.data!.id!;

  return useQuery(plaidTokenLinkKeyFn({ userId, ...request }), () => postPlaidCreateTokenLink({ userId, ...request }), {
    ...options,
    staleTime: options?.staleTime ?? 0,
    enabled: (options?.enabled ?? true) && userId != null,
  });
}
